import React, { useContext, useEffect, useState } from 'react';
import styles from './Results.module.scss';
import Map from '../../components/map/Map';
import SearchBar from '../../components/search-bar/SearchBar';
import Paginator from '../../components/paginator/Paginator';
import FilterBar from '../../components/filter-bar/FilterBar';
import HeaderControls from '../../components/header-controls/HeaderControls';
import DirectoryButtonArea from '../../components/directory-button-area/DirectoryButtonArea';
import axios, { AxiosResponse } from 'axios';
import { DirectoryListType } from '../../components/directory-list/DirectoryList';
import { checkValidZip, distanceOptions, evaluateIsDisabled, getCurrentPosition, isEmptyZip, mapToGenericResults } from '../../lib/util';
import IGenericResult from '../../interfaces/IGenericResult';
import * as _ from 'lodash';
import ProfileCard from '../../components/profile-card/ProfileCard';
import { AppContext } from '../../context/AppContext';
import { IAppContext, defaultAppState } from '../../context/DefaultAppState';

import SecondaryControls from '../../components/secondary-controls/SecondaryControls';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import IDistance from '../../interfaces/IDistance';
import ISearch from '../../interfaces/ISearch';

export interface IResultsFilter {
  specialty: string | null;
  acceptanceStatus: string | null;
  sortType: ResultSortType;
}

export enum ResultSortType {
  none,
  namesAsc,
  namesDesc,
  specialtiesAsc,
  specialtiesDesc,
  acceptanceStatusAsc,
  acceptanceStatusDesc
}

const ResultsPage = ( props: any ) => {
  const [rawResults, setRawResults] = useState<IGenericResult[]>([]);
  const [chunks, setResultChunks] = useState<IGenericResult[][]>([]);
  const [showEmailField, setShowEmailField] = useState(false);
  const [resultsFilter, setResultsFilter] = useState<IResultsFilter>({ specialty: null, acceptanceStatus: null, sortType: ResultSortType.none });
  const { planCode, directory, specialty, name, location } = props.match.params;
  const urlLocation = props.location.search;
  const [currentPage, setCurrentPage] = useState(0);
  const [validationMessage, setValidationMessage] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [profileDirections, setProfileDirections] = useState();
  const [currentLocation, setCurrentLocation] = useState<{ lat: number; lng: number }>();
  const appContext = useContext(AppContext);

  const hashParams = new URLSearchParams(urlLocation);
  const tempDistance = hashParams.get('distance');
  const [isLoading, setIsLoading] = useState(true); 

  useEffect(() => {
    initializeResults(planCode, directory, name, specialty, location, tempDistance, setRawResults, appContext, setIsLoading);
    appContext.updateChosenSpecialty(specialty);
  }, [appContext.plansData]);
  

  
  useEffect(() => {
    const processResults = async () => {
      try {
        await setResultChunks(chunkResults(rawResults)); // Process data
      } catch (error) {
        console.error('Error processing results:', error);
      }
    };
  
    processResults(); // Call the function to process results
  }, [rawResults, resultsFilter]);
      const chunkResults = (results: IGenericResult[]): IGenericResult[][] => {
    let filteredResults = results;

    if (resultsFilter.specialty && resultsFilter.specialty.toUpperCase() !== 'ALL SPECIALTIES') {
      filteredResults = filteredResults.filter((r) => r.specialty.toUpperCase() === resultsFilter.specialty?.toUpperCase());
    }

    if (resultsFilter.acceptanceStatus && resultsFilter.acceptanceStatus !== '') {
      filteredResults = filteredResults.filter((r) => r.acceptingNewPatients?.toUpperCase() === resultsFilter.acceptanceStatus?.toUpperCase());
    }

    switch (parseInt(resultsFilter.sortType.toString())) {
      case ResultSortType.none:
        break;
      case ResultSortType.namesAsc:
        filteredResults = _.orderBy(filteredResults, 'name', 'asc');
        break;
      case ResultSortType.namesDesc:
        filteredResults = _.orderBy(filteredResults, 'name', 'desc');
        break;
      case ResultSortType.specialtiesAsc:
        filteredResults = _.orderBy(filteredResults, 'specialty', 'asc');
        break;
      case ResultSortType.specialtiesDesc:
        filteredResults = _.orderBy(filteredResults, 'specialty', 'desc');
        break;
      case ResultSortType.acceptanceStatusAsc:
        filteredResults = _.orderBy(filteredResults, 'acceptingNewPatients', 'asc');
        break;
      case ResultSortType.acceptanceStatusDesc:
        filteredResults = _.orderBy(filteredResults, 'acceptingNewPatients', 'desc');
        break;
      default:
        break;
    }
    
    return _.chunk(filteredResults, 4);
  };

  return (
    <div id="results-pdf-container">
      <div className="header-container-mini">
        <HeaderControls />
        <DirectoryButtonArea />
        <div className="select-mini-bg">
          <SearchBar />
        </div>
        {appContext.isDisabled && appContext.search.isValidZIP && appContext.search.required === false ? (
          <div className={'required'}>
            <p></p>
            <p>Please input a valid ZIP Code.</p>
            <p></p>
          </div>
          
        ) : null}
        {appContext.isDisabled && !appContext.search.isValidZIP && appContext.search.required === false ? (
          <div className={'required'}>
            <p></p>
            <p>Please input a valid ZIP Code or leave it blank.</p>
            <p></p>
          </div>
        ) : null}
        <SecondaryControls pdfContainerId="results-pdf-container" showEmailField={showEmailField} setShowEmailField={setShowEmailField} />
      </div>
      <div>
        {showEmailField ? (
          <>
            <div className={styles.emailFieldContainer}>
              <h4>Email Result</h4>
              <p>Please Enter an Email Address</p>
              <input type="text" placeholder={'example: john.doe@example.com'} onChange={(e) => setUserEmail(e.target.value)}/>
              <button className={styles.profileButton} onClick={() => validateEmail( userEmail, setValidationMessage, () => {downloadPdf('Directory Results', 100, 'results-pdf-container',true, userEmail); setShowEmailField(!showEmailField)})}>Send Email</button>
              <p className={styles.error}>{validationMessage}</p>
            </div>
          <hr/>
          </>
        ) : null}
 {!isLoading && (
  <FilterBar 
    resultCount={chunks.reduce((count, chunk) => (count += chunk.length), 0)} 
    resultsFilterMethod={setResultsFilter} 
    resultsFilterValue={resultsFilter} 
  />
)}      </div>
      {isLoading ? (
            <div style={{width: '100%',textAlign: 'center',marginTop: '25px',fontSize: '21px'}} className={styles.loadingContainer}>
              Loading results...
            </div>
          ): null}
      <div className={styles.resultsPageContainer}>  
      
        <div className={styles.profileColumn}>
          {/* Loading image 
          {chunks && (
            <div className={styles.loadingContainer}>
              Loading results 1...
            </div>
          )}
          */}
          {chunks ? chunks[currentPage]?.map((result, index) => <ProfileCard result={result} key={`pc-${index}`} profileCardIndex={index} handleDirections={setProfileDirections} planState={appContext.planState} />) : '<div className={styles.loadingContainer}>Loading results...</div>' }
        </div>
        <div className={styles.mapColumn}>
          <Map currentChunk={chunks[currentPage] || []} profileDirections={profileDirections} planState={appContext.planState} />
        </div>
      </div>
      {!isLoading && chunks.length > 0 && (
  <Paginator
    resultChunks={chunks}currentPage={currentPage} setCurrentPage={setCurrentPage} />
)}    </div>
    
  );
 
};

const initializeResults = async (
  planCode: string | null,
  directory: string | null,
  name: string | null,
  specialty: string | null,
  location: string | null,
  distance: string | null,
  setStateMethod: React.Dispatch<React.SetStateAction<IGenericResult[]>>,
  appContext: IAppContext,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>> // Pass setIsLoading as a parameter
) => {
  let apiRoute = '';
  switch (directory) {
    case DirectoryListType.doctor:
      apiRoute = 'Doctors';
      break;
    case DirectoryListType.facility:
      apiRoute = 'Facilities';
      break;
    case DirectoryListType.pharmacy:
      apiRoute = 'Pharmacies';
      break;
    default:
      apiRoute = 'All';
      break;
  }

  try {
    // Set loading to true at the start
    setIsLoading(true);

    const distanceParam = distance && parseInt(distance) > 0 ? `?distance=${distance}` : '';
    const reqUrl =
      apiRoute === 'All'
        ? `/${apiRoute}/Results/${planCode}/${name}`
        : `/${apiRoute}/Results/${planCode}/${specialty}/${name}/${location}${distanceParam}`;
    console.log(reqUrl);

    const { data } = await axios.get(reqUrl);
    const results = mapToGenericResults(data);

    rebuildContext(planCode, directory, name, specialty, location, distance, appContext);
    setStateMethod(results);
  } catch (error) {
    console.error('Error fetching results:', error);
  } finally {
    // Ensure loading is set to false after the API call finishes
    setIsLoading(false);
  }
};


const rebuildContext = (planCode: string | null, directory: string | null, name: string | null, specialty: string | null, location: string | null, distance: string | null, appContext: IAppContext) => {
  if (planCode) {
    const currentPlan = appContext.plansData.find(p => p.contractId === planCode);

    if(currentPlan) {
      appContext.updatePlanCode(planCode);
      appContext.updatePlan(currentPlan);
      appContext.updatePlanName(currentPlan.planName);
      appContext.updateDisclaimerUrl(currentPlan.ipdDisclaimerLink);
      appContext.updatePlanState(currentPlan.state);
    }
  }

  if (directory) {
    switch (directory) {
      case DirectoryListType.doctor:
        appContext.updateListType(DirectoryListType.doctor);
        appContext.updateSelected(true);
        break;
      case DirectoryListType.facility:
        appContext.updateListType(DirectoryListType.facility);
        appContext.updateSelected(true);
        break;
      case DirectoryListType.pharmacy:
        appContext.updateListType(DirectoryListType.pharmacy);
        appContext.updateSelected(true);
        break;
      case DirectoryListType.all:
        appContext.updateListType(DirectoryListType.all);
        appContext.updateSelected(true);
        break;
      default:
        appContext.updateListType(DirectoryListType.none);
        appContext.updateSelected(false);
        break;
    }
  }

  if (name) {
    appContext.updateName(name);
  }

  if (specialty) {
    appContext.updateSelectedSpecialty(specialty);
  }

  let newSearch = defaultAppState.search;
  console.log('newSearch: ', newSearch)
  if (location) {
    appContext.updateLocation(location);
    
    const result = checkValidZip(location);

    newSearch = { ...newSearch, isValidZIP: result }
  }

  console.log('middle newSearch: ', newSearch)
  
  if (distance) {
    const optionalDistances = distanceOptions();
    const distanceObject: any = optionalDistances.find( (distanceObj) => distanceObj.distance.toString() === distance);
    appContext.updateDistance(distanceObject);

    if (distanceObject.distance !== defaultAppState.distance.distance) {
      //console.log('other distance')
      newSearch = { ...newSearch, required: true }

    }
  }
  const updatedSearch: ISearch = {
    required: newSearch.required,
    isValidZIP: newSearch.isValidZIP
  } ;

  appContext.updateSearch( updatedSearch );
  let currentLocation = location ? location : null;
  let tempDistance = distance ? parseInt(distance) : defaultAppState.distance.distance;
  const valueResult = evaluateIsDisabled(updatedSearch, currentLocation, tempDistance);
  console.log(updatedSearch, currentLocation, tempDistance, valueResult);
  appContext.updateIsDisabled(valueResult);

};

const validateEmail = (email: string, setValidationMessage: any, callback: () => void) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  let isValid = regex.test(email);

  if(isValid) {
    setValidationMessage('');
    callback();
  } else {
    setValidationMessage('Email is not valid. Please check that the email address entered is formatted correctly.')
  }
}

const downloadPdf = (pdfName: string, heightModifier: number, pdfContainerId: string, packageForEmail?: boolean, email?: string) => {
  const input = document.getElementById(pdfContainerId);
  html2canvas(input as HTMLElement)
    .then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'pt', 'a4');
      const height = 500 + heightModifier;
      console.log(height);
      pdf.addImage(imgData, 'PNG', 0, 0, 600, height);
      // pdf.output('dataurlnewwindow');
      if(!packageForEmail) {
        pdf.save(`${pdfName}.pdf`);
      } else {
        console.log({ planTitle: window.location.host.split('.')[0],
          planBase: window.location.host === 'localhost:3000' ? 'alignseniorcare.com' : window.location.host,
          fileAttachment: btoa(pdf.output()),
          fileName: pdfName,
          userEmail: email})

        axios.post(`/SendEmail`, {
          planTitle: window.location.host.split('.')[0],
          planBase: window.location.host === 'localhost:3000' ? 'alignseniorcare.com' : window.location.host,
          fileAttachment: btoa(pdf.output()),
          fileName: pdfName,
          userEmail: email
        }).then(res => {
          console.log(res)
        }).catch(err => {
          console.error(err);
        })
      }
    });
}

const getDistances = (
  origin: string,
  destinationArray: any[],
  service: google.maps.DistanceMatrixService
): Promise<google.maps.DistanceMatrixResponse> => {
  const origins = [origin];

  return new Promise((resolve, reject) => {
    const callback = (
      response: google.maps.DistanceMatrixResponse | null,
      status: google.maps.DistanceMatrixStatus
    ) => {
      if (status === google.maps.DistanceMatrixStatus.OK && response) {
        resolve(response);
      } else {
        reject(status);
      }
    };

    service.getDistanceMatrix(
      {
        origins,
        destinations: destinationArray,
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.IMPERIAL
      },
      callback
    );
  });
};

const rateLimit = async () => {

}

export default ResultsPage;
